import { Component, Input } from '@angular/core';
import { RouteQueryParam } from '../../models/routeQueryParam.model';

type ActionFunction = (rowData: any) => void;

@Component({
  selector: 'pv-link-display-column',
  templateUrl: './link-display-column.component.html',
  styleUrls: ['./link-display-column.component.scss']
})
export class LinkDisplayColumnComponent {

  @Input() icon!: string;
  @Input() faClass?: string;
  @Input() routerLink?: string | any[];
  @Input() routeQueryParam?: RouteQueryParam;
  @Input() rowData?: any;
  @Input() customAction?: ActionFunction;
  @Input() routerText: string = '';
  @Input() status: string = 'default';

  get computedQueryParams(): { [key: string]: any } | null {
    if (!this.routeQueryParam?.queryName || !this.rowData) {
      return null;
    }
    
    const value = this.rowData[this.routeQueryParam.rowDataKey];
    return value ? { [this.routeQueryParam.queryName]: value } : null;
  }

  handleCustomAction(): void {
    if (this.customAction && this.rowData) {
      this.customAction(this.rowData);
    }
  }

  get shouldUseRouterLink(): boolean {
    return !!this.routerLink;
  }
}
